export class AppUrlConfig {
  static readonly LOGIN_URL = '/auth-user/login';
  static readonly HOME_URL = '/home';
  static readonly BREADCRUMB_TEST_PAGE_URL = '/breadcrumb-demo';
}
